exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ui-dialog .ui-dialog-content{overflow:initial!important}", ""]);

// exports
